var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHeartActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.775 0C12.1525 0 13.75 2.235 13.75 4.32C13.75 8.5425 7.12 12 7 12C6.88 12 0.25 8.5425 0.25 4.32C0.25 2.235 1.8475 0 4.225 0C5.59 0 6.4825 0.6825 7 1.2825C7.5175 0.6825 8.41 0 9.775 0Z",
    fill: "#FF6741"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeartActive);
export default __webpack_public_path__ + "static/media/icon_heart_active.7e5523e616c163ffc95d2ad82b71aa17.svg";
export { ForwardRef as ReactComponent };